export default __webpack_public_path__ + "static/media/hero-image-2.071084dc.png";